<div class="idp-fast-action-banner-container">
  <div
    [ngClass]="{
      '--width-full': styles?.offer?.containerStyles?.width === 'full',
      '--enrollment': config.enrollmentTheme
    }"
    class="idp-fast-action-banner-card"
  >
    <div
      [ngStyle]="getBorderStyles('bottom')"
      [ngClass]="
        styles.offer.actionOrientation === 'vertical'
          ? '--vertical'
          : '--horizontal'
      "
      class="idp-fast-action-banner-card--container"
    >
      <div class="idp-fast-action-banner--offer-details">
        <idp-offer-details-banner
          (openLink)="changeTab($event)"
          [benefitStyles]="styles.offer.benefit ?? {}"
          [benefit]="content.benefit ?? ''"
          [config]="config"
          [containerStyles]="styles.offer.containerStyles ?? {}"
          [detailsStyles]="styles.offer.details ?? {}"
          [details]="content.details ?? ''"
          [feeStyles]="styles.offer.annualFee ?? {}"
          [fee]="content.annualFee ?? ''"
          [headlineStyles]="styles.offer.heading1 ?? {}"
          [headline]="content.headline ?? ''"
          [imageStyles]="styles.offer.image ?? {}"
          [image]="content.image"
          [linksStyles]="styles.offer.links ?? {}"
          [links]="content.links ?? []"
          [offerStyles]="styles.offer.heading2 ?? {}"
          [offer]="(content.offer | safe : 'html') ?? ''"
          [orientation]="styles.offer.actionOrientation ?? 'horizontal'"
          [displaySecondaryHeader]="displaySecondaryHeader"
        ></idp-offer-details-banner>
      </div>
      <idp-offer-action-banner
        (offerAction)="notifyAction($event)"
        *ngIf="config.showAction"
        [backgroundColor]="styles.offer.checkSectionBackgroundColor ?? ''"
        [buttonLabelStyles]="styles.offer.buttonLabel ?? {}"
        [actionSize]="styles.offer.actionSize ?? 'full-width'"
        [actionType]="styles.offer.actionType ?? 'secondary'"
        [buttonLabel]="content.action?.link?.label"
        [buttonUrl]="content.action?.link?.url"
        [buttonId]="content.action?.linkId"
        [secondaryLinkId]="content.action?.secondaryLinkId"
        [secondaryLink]="content.action?.secondaryLink"
        [inputType]="content.action?.input ?? 'checkbox'"
        [messageStyles]="styles.offer.checkLabel ?? {}"
        [message]="setActionMessages(content)"
        [orientation]="
          content.action?.enable && !content?.pageId?.includes('confirmation')
            ? 'horizontal'
            : 'vertical'
        "
        [axTitle]="title"
      ></idp-offer-action-banner>
    </div>
  </div>
  <span
    *ngIf="config.showCreditSummary"
    class="idp-offer-credit-banner-container"
  >
    <idp-offer-credit-banner
      [content]="content.summary"
      [styles]="creditSummaryStyles"
    ></idp-offer-credit-banner>
  </span>
</div>
